<template>
  <div id="app">
    <Top v-if="indexMenus.length" />
    <router-view v-if="indexMenus.length" />
    <Footer />
    <backTop />
  </div>
</template>

<script>
import backTop from "@/components/backTop.vue";
export default {
  name: "App",
  components: {
    backTop,
  },
  data() {
    return {
      indexMenus: [],
    };
  },
  created() {
    this.loadMenu();
    if (this.windowWidth < 770) {
      window.location.href = "https://mcth5.drcnet.com.cn/#/";
    }
  },
  methods: {
    // 菜单栏
    async loadMenu() {
      const { code, data } = await this.$api.get("/getIndexMenu");
      if (code === 0) {
        this.indexMenus = data;
        this.$store.commit("updateIndexMenus", data);
      }
    },
  },
  watch: {
    windowWidth(newValue) {
      if (newValue < 770) {
        window.location.href = "https://mcth5.drcnet.com.cn/#/";
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@media screen and (max-width: 769px) {
  ::v-deep .home {
    width: 100% !important;
  }
}
</style>
